import { ThemeUIStyleObject } from "theme-ui";

const layoutTaxonomies = {
  // Cards/Events/News HOC
  hc_list_layout_1: [
    {
      col: [12, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
    {
      col: [12, 12, 3],
      ratio: ["340:532", "675:500", "319:500"],
    },
    {
      col: [12, 12, 6],
      children: [
        {
          col: [12, 6, 12],
          ratio: ["340:532", "340:532", "675:500"],
        },
        {
          col: [12, 6, 6],
          ratio: ["340:532", "340:532", "319:500"],
        },
        {
          col: [12, 12, 6],
          ratio: ["340:532", "675:500", "319:500"],
        },
      ],
    },
    {
      col: [12, 6, 6],
      ratio: ["340:532", "340:532", "675:1034"],
    },
    {
      col: [12, 6, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
    {
      col: [12, 6, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
  ],
  hc_list_layout_1_reverse: [
    {
      col: [12, 6, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
    {
      col: [12, 6, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
    {
      col: [12, 6, 6],
      ratio: ["340:532", "340:532", "675:1034"],
    },
    {
      col: [12, 12, 6],
      children: [
        {
          col: [12, 12, 6],
          ratio: ["340:532", "675:500", "319:500"],
        },
        {
          col: [12, 6, 6],
          ratio: ["340:532", "340:532", "319:500"],
        },
        {
          col: [12, 6, 12],
          ratio: ["340:532", "340:532", "675:500"],
        },
      ],
    },
    {
      col: [12, 12, 3],
      ratio: ["340:532", "675:500", "319:500"],
    },
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
    {
      col: [12, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
  ],
  hc_list_layout_2: [
    {
      col: [12, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
    {
      col: [12, 12, 3],
      ratio: ["340:532", "675:500", "319:500"],
    },
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
    {
      col: [12, 12, 3],
      ratio: ["340:532", "675:500", "319:500"],
    },
    {
      col: [12, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
  ],
  hc_list_layout_2_reverse: [
    {
      col: [12, 12, 3],
      ratio: ["340:532", "675:500", "319:500"],
    },
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
    {
      col: [12, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
    {
      col: [12, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
    {
      col: [12, 12, 3],
      ratio: ["340:532", "675:500", "319:500"],
    },
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
  ],
  hc_list_layout_3: [
    {
      col: [12, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
    {
      col: [12, 6],
      ratio: ["340:532", "340:532", "675:500"],
    },
  ],
  hc_list_layout_4: [
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
    {
      col: [12, 6, 3],
      ratio: ["340:532", "340:532", "319:500"],
    },
  ],
};

export interface layoutProps {
  col: string | string[] | number | number[];
  ratio: string | string[];
  large?: boolean;
  sx?: ThemeUIStyleObject;
  children: {
    col: number | number[];
    ratio: string | string[];
    sx?: ThemeUIStyleObject;
  };
}

export class ListLayout {
  taxonomi?: layoutProps[];
  taxonomies: string[];

  constructor(taxonomies: string[], defaultTaxonomi?: string) {
    this.taxonomies = taxonomies;

    const foundTax = Object.keys(layoutTaxonomies).find((tax) =>
      this.taxonomies.includes(tax)
    );

    this.taxonomi =
      (foundTax && layoutTaxonomies[foundTax]) ||
      (defaultTaxonomi && layoutTaxonomies[defaultTaxonomi]);

    if (!this.taxonomi) {
      return;
    }
  }
}
